import { IReportor } from "src/modules/Dashboard/ManagerDashboard/types";

export const separateSubOrdinatesByLevels = (reports: IReportor[]): [IReportor, IReportor[], IReportor[]] => {
  const zerothLevel = reports.find(report => report.level === 0) as IReportor;
  const firstLevels = reports.filter(report => report.level === 1);
  const secondLevels = reports.filter(report => report.level === 2);

  return [zerothLevel, firstLevels, secondLevels];
};
